import React from "react";
import { Box, Typography, IconButton, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const themeColors = {
  primary: "#45B5B9",
  secondary: "#DF7468",
  background: "#FFFFFF",
  text: "#41444B",
  cardColors: [
    "#FDE36F", // Yellow
    "#F2B994", // Orange
    "#E89FB2", // Pink
    "#64CBCC", // Turquoise
    "#487C9E", // Blue
  ],
};

const ChatTemplates = ({ templates, onTemplateSelect, isOpen, onToggle }) => {
  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <Box
        sx={{
          p: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            sx={{
              fontFamily: "Merriweather",
              fontWeight: 700,
              fontSize: 13,
              textTransform: "uppercase",
              color: themeColors.text,
            }}
          >
            Discover
          </Typography>
        </Box>
        <IconButton onClick={onToggle} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Templates Grid */}
      <Box
        sx={{
          p: 3,
          flexGrow: 1,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Merriweather",
            fontWeight: 700,
            fontSize: 24,
            color: themeColors.text,
            mb: 2,
          }}
        >
          Popular Questions
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 2,
          }}
        >
          {templates.map((template, index) => (
            <Paper
              key={index}
              onClick={() => onTemplateSelect(template.prompt)}
              sx={{
                p: 2,
                bgcolor:
                  themeColors.cardColors[index % themeColors.cardColors.length],
                borderRadius: "5px",
                cursor: "pointer",
                transition: "transform 0.2s ease",
                "&:hover": {
                  transform: "scale(1.02)",
                },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                minHeight: 100,
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 700,
                  fontSize: 14,
                  color: themeColors.text,
                  lineHeight: 1.5,
                }}
              >
                {template.title}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ChatTemplates;
